'use strict';

import './radio-or-checkbox/component.scss';

import 'components/tooltip';
import './core';
import './field';
import './validation';